export function sortByName(a, b) {
  const nombreA = a.toUpperCase();
  const nombreB = b.toUpperCase();

  if (nombreA < nombreB) {
    return -1;
  }
  if (nombreA > nombreB) {
    return 1;
  }
  return 0;
}
